function padValues(unit: number) {
  return unit > 9 ? String(unit) : `0${unit}`;
}

export function msToTimestamp(timestamp: number) {
  if (timestamp === 0) {
    return '00:00:00';
  }

  const msInHour = 3600000;
  const msInMinute = 60000;
  const msInsecond = 1000;

  const timestampToHours = Math.floor(timestamp / msInHour);
  const timestampMinusHours = Math.floor(timestamp - msInHour * timestampToHours);
  const timestampToMinutes = Math.floor(timestampMinusHours / msInMinute);
  const timestampMinusMinutes = Math.floor(timestampMinusHours - msInMinute * timestampToMinutes);
  const timestampToSeconds = Math.floor(timestampMinusMinutes / msInsecond);

  return [padValues(timestampToHours), padValues(timestampToMinutes), padValues(timestampToSeconds)].join(':');
}
